/* tslint:disable */
/* eslint-disable */
/**
 * OpenShifts.WebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { ClosePayPeriodRequest } from '../api-models';
// @ts-ignore
import { ClosePayPeriodResponse } from '../api-models';
// @ts-ignore
import { ClosePayPeriodSetupResponse } from '../api-models';
// @ts-ignore
import { ProblemDetails } from '../api-models';
/**
 * ClosePayPeriodV2Api - axios parameter creator
 * @export
 */
export const ClosePayPeriodV2ApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Closes the group\'s pay periods up to and including the chosen one: the named period is  closed with an audit row (Pay Period Before Previous leaves it open), every older open  period is closed without one, and periods past their open-to date and time close as  LegacyApp closes them when its configuration loads. One transaction.
         * @param {ClosePayPeriodRequest} [closePayPeriodRequest] The form\&#39;s choices.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ToolsClosePayPeriodPost: async (closePayPeriodRequest?: ClosePayPeriodRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/tools/close-pay-period`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(closePayPeriodRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Form defaults: the pay period group combo and the radio checked on open.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ToolsClosePayPeriodSetupGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/tools/close-pay-period/setup`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ClosePayPeriodV2Api - functional programming interface
 * @export
 */
export const ClosePayPeriodV2ApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ClosePayPeriodV2ApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Closes the group\'s pay periods up to and including the chosen one: the named period is  closed with an audit row (Pay Period Before Previous leaves it open), every older open  period is closed without one, and periods past their open-to date and time close as  LegacyApp closes them when its configuration loads. One transaction.
         * @param {ClosePayPeriodRequest} [closePayPeriodRequest] The form\&#39;s choices.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2ToolsClosePayPeriodPost(closePayPeriodRequest?: ClosePayPeriodRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClosePayPeriodResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2ToolsClosePayPeriodPost(closePayPeriodRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Form defaults: the pay period group combo and the radio checked on open.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2ToolsClosePayPeriodSetupGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClosePayPeriodSetupResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2ToolsClosePayPeriodSetupGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ClosePayPeriodV2Api - factory interface
 * @export
 */
export const ClosePayPeriodV2ApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ClosePayPeriodV2ApiFp(configuration)
    return {
        /**
         * 
         * @summary Closes the group\'s pay periods up to and including the chosen one: the named period is  closed with an audit row (Pay Period Before Previous leaves it open), every older open  period is closed without one, and periods past their open-to date and time close as  LegacyApp closes them when its configuration loads. One transaction.
         * @param {ClosePayPeriodV2ApiApiV2ToolsClosePayPeriodPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ToolsClosePayPeriodPost(requestParameters: ClosePayPeriodV2ApiApiV2ToolsClosePayPeriodPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<ClosePayPeriodResponse> {
            return localVarFp.apiV2ToolsClosePayPeriodPost(requestParameters.closePayPeriodRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Form defaults: the pay period group combo and the radio checked on open.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ToolsClosePayPeriodSetupGet(options?: AxiosRequestConfig): AxiosPromise<ClosePayPeriodSetupResponse> {
            return localVarFp.apiV2ToolsClosePayPeriodSetupGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV2ToolsClosePayPeriodPost operation in ClosePayPeriodV2Api.
 * @export
 * @interface ClosePayPeriodV2ApiApiV2ToolsClosePayPeriodPostRequest
 */
export interface ClosePayPeriodV2ApiApiV2ToolsClosePayPeriodPostRequest {
    /**
     * The form\&#39;s choices.
     * @type {ClosePayPeriodRequest}
     * @memberof ClosePayPeriodV2ApiApiV2ToolsClosePayPeriodPost
     */
    readonly closePayPeriodRequest?: ClosePayPeriodRequest
}

/**
 * ClosePayPeriodV2Api - object-oriented interface
 * @export
 * @class ClosePayPeriodV2Api
 * @extends {BaseAPI}
 */
export class ClosePayPeriodV2Api extends BaseAPI {
    /**
     * 
     * @summary Closes the group\'s pay periods up to and including the chosen one: the named period is  closed with an audit row (Pay Period Before Previous leaves it open), every older open  period is closed without one, and periods past their open-to date and time close as  LegacyApp closes them when its configuration loads. One transaction.
     * @param {ClosePayPeriodV2ApiApiV2ToolsClosePayPeriodPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClosePayPeriodV2Api
     */
    public apiV2ToolsClosePayPeriodPost(requestParameters: ClosePayPeriodV2ApiApiV2ToolsClosePayPeriodPostRequest = {}, options?: AxiosRequestConfig) {
        return ClosePayPeriodV2ApiFp(this.configuration).apiV2ToolsClosePayPeriodPost(requestParameters.closePayPeriodRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Form defaults: the pay period group combo and the radio checked on open.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClosePayPeriodV2Api
     */
    public apiV2ToolsClosePayPeriodSetupGet(options?: AxiosRequestConfig) {
        return ClosePayPeriodV2ApiFp(this.configuration).apiV2ToolsClosePayPeriodSetupGet(options).then((request) => request(this.axios, this.basePath));
    }
}
